export default {
  data() {
    return {
      masterFiles: [
        { name: 'Sub-contractor', value: 'contractor' },
        { name: 'Vehicle', value: 'vehicle' },
        { name: 'Driver', value: 'driver' },
      ],
    }
  },
  computed: {
    driverObj() {
      if (this.batchEntry) {
        var id = this.editedLine.driverId;
      } else {
        var id = this.driverId;
      }
      if (!id) return null
      return this.getObjByPrimaryId(id, this.drivers)
    },
    vehicleObj() {
      if (this.batchEntry) {
        var id = this.editedLine.vehicleId;
      } else {
        var id = this.vehicleId;
      }
      if (!id) return null
      return this.getObjByPrimaryId(id, this.vehicles)
    },
    contractorObj() {
      var id = this.contractorId;
      if (!id) return null
      return this.getObjByPrimaryId(id, this.contractors)
    },
    tipObj() {
      if (this.batchEntry) {
        var id = this.editedLine.tipId;
      } else {
        var id = this.tipId;
      }
      if (!id) return null
      return this.getObjByPrimaryId(id, this.tips)
    },
    spoilObj() {
      if (this.batchEntry) {
        var id = this.editedLine.spoilId;
      } else {
        var id = this.spoilId;
      }
      if (!id) return null
      return this.getObjByPrimaryId(id, this.spoils)
    }
  }
}